export const getFontFamily = (fontStyle) => {
  const fontMap = {
    'printed': 'system-ui, -apple-system, sans-serif',
    'messy-1': '"Caveat", cursive',
    'messy-2': '"Satisfy", cursive',
    'messy-3': '"Dancing Script", cursive',
    'messy-4': '"Pacifico", cursive',
    'messy-5': '"Patrick Hand", cursive'
  };
  return fontMap[fontStyle] || fontMap['printed'];
};

export const getPenColor = (colorId) => {
  const colorMap = {
    'black': '#000000',
    'blue': '#0000FF',
    'dark-blue': '#000080',
    'red': '#DC2626',
    'green': '#059669'
  };
  return colorMap[colorId] || colorMap['black'];
};

export const getClinicLogo = (logoId) => {
  const logoMap = {
    'logo-1': '🏥',
    'logo-2': '⚕️',
    'logo-3': '❤️+',
    'logo-4': '🩺',
    'logo-5': '🏨',
    'logo-6': '🌿',
    'logo-7': '🧬',
    'logo-8': ''
  };
  return logoMap[logoId] || logoMap['logo-1'];
};

export const getMastheadColor = (colorId) => {
  const colorMap = {
    'red': '#DC2626',
    'blue': '#2563EB',
    'green': '#059669',
    'teal': '#0D9488',
    'purple': '#7C3AED',
    'maroon': '#7F1D1D',
    'navy': '#1E3A8A',
    'gray': '#4B5563'
  };
  return colorMap[colorId] || colorMap['red'];
};

export const getTemplateStyle = (templateStyle) => {
  const styleMap = {
    'classic': {
      borderColor: '#DC2626',
      headerBg: '#FEE2E2',
      accentColor: '#DC2626'
    },
    'modern': {
      borderColor: '#2563EB',
      headerBg: '#DBEAFE',
      accentColor: '#2563EB'
    },
    'government': {
      borderColor: '#059669',
      headerBg: '#D1FAE5',
      accentColor: '#059669'
    },
    'private': {
      borderColor: '#7C3AED',
      headerBg: '#EDE9FE',
      accentColor: '#7C3AED'
    },
    'multispecialty': {
      borderColor: '#0D9488',
      headerBg: '#CCFBF1',
      accentColor: '#0D9488'
    },
    'ayurvedic': {
      borderColor: '#059669',
      headerBg: '#ECFDF5',
      accentColor: '#059669'
    }
  };
  return styleMap[templateStyle] || styleMap['classic'];
};